import createTheme from '@material-ui/core/styles/createMuiTheme'
import { AppThemeOptions } from '../types/main'

export const appCreateTheme = (options?: AppThemeOptions) => {
  return createTheme(options)
}
